var _excluded = ["size"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { Avatar as MuiAvatar, styled } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
var Root = styled(MuiAvatar, {
  label: 'MnrlAvatar-root'
})(function (_ref) {
  var sizeProp = _ref.ownerState.size,
      theme = _ref.theme;
  var size = sizeProp === 'small' ? 24 : sizeProp === 'medium' ? 32 : sizeProp;
  var fontSize = sizeProp === 'small' ? theme.typography.pxToRem(11) : sizeProp === 'medium' ? theme.typography.pxToRem(14) : typeof sizeProp === 'number' ? theme.typography.pxToRem(sizeProp / 2) : undefined;
  return {
    height: size,
    width: size,
    fontSize: fontSize,
    '> .MuiSvgIcon-root': {
      width: '75%',
      height: '75%'
    }
  };
});
export var Avatar = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'medium' : _ref2$size,
      restProps = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/_jsx(Root, _extends({
    ownerState: {
      size: size
    }
  }, restProps, {
    ref: ref
  }));
});